import apiClient from '../util/ApiClient';

export const getActivePlans = async function () {

    let result = await apiClient.get('Plan/GetActivePlans');
    return result.data;
}